import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { connect } from '../../../../react-redux';
import { getTimerData, getIsTaking } from '../../../../selectors/taking';
import { getActiveQuizSession } from '../../../../selectors/quizSessions';
import Timer from './presenter';
import { screenreaderNotification } from '../../../../actions/alerts';
import { updateTimerMinimized } from '../../../../actions/taking';
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    screenreaderNotification: bindActionCreators(screenreaderNotification, dispatch),
    updateTimerMinimized: bindActionCreators(updateTimerMinimized, dispatch)
  };
};
var mapStateToProps = function mapStateToProps(state) {
  var timerData = getTimerData(state).toJS();
  var isTaking = getIsTaking(state);
  var activeQuizSession = getActiveQuizSession(state);
  var takingData = activeQuizSession.takingData || Map();
  return {
    showTimer: takingData.get('timeAllowed') > 0,
    timerRunning: isTaking && timerData.timerRunning,
    timeLeftInSeconds: timerData.timeLeftInSeconds,
    timerMinimized: timerData.timerMinimized
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Timer);